const register = (userInfo, provider) => {
    return async (dispatch, getState, { getFirebase, getFirestore }) => {
        const fb = getFirebase();
        const db = getFirestore();
        const { email, username, password } = userInfo

        try {
            const requestRegisteredUsersNames = await db.collection('usersNames').doc('users').get()
            const getRegisteredUsersNames = requestRegisteredUsersNames.data()
            var format = /[`@#$%^&*_\\[\]{}\\|<>\/~]/

            if (username.length > 10) {
                dispatch({ type: 'REGISTER_ERROR', error: 'Ocorreu um erro no registo! O nome inseriu possuí mais de 10 letras/caracteres' });
            } else if (format.test(username)) {
                dispatch({ type: 'REGISTER_ERROR', error: 'Ocorreu um erro no registo! O nome que inseriu possuí símbolos especiais' });
            } else if (getRegisteredUsersNames.tookNames.find(name => name === username)) {
                dispatch({ type: 'REGISTER_ERROR', error: 'Ocorreu um erro no registo! Já existe um utilizador com o mesmo nome' });
            } else {
                const sendRegister = await fb.auth().createUserWithEmailAndPassword(email, password)
                const uid = sendRegister.user.uid
                await db.collection('users').doc(uid).set({
                    createdAt: db.FieldValue.serverTimestamp(),
                    username: username,
                    avatar: 'matilde-normal',
                    experience: 0,
                    experiencePercentage: 0,
                    level: 1,
                    statute: 'Viajante curiosa e inexperiente',
                    matildeNotif: true,
                    achievements: [],
                    reactionItems: [],
                    inventory: {
                        bag: [],
                        hats: []
                    },
                    travelBook: [],
                    travels: {
                        completedTravels: [],
                    },
                    studyGame: 0,
                    favoriteCountries: [],
                    comments: [],
                    advices: []
                })
                dispatch({ type: 'REGISTER_SUCCESS' });
            }

        } catch (err) {
            dispatch({ type: 'REGISTER_ERROR', payload: err.message });
        }

        /*if (provider === 'google') {
            var provider = new firebase.auth.GoogleAuthProvider();
            provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
            firebase.auth().languageCode = 'pt';
            try {
            } catch (err) {
            }
        } else if (provider === 'fb') {
            try {
            } catch (err) {
            }
        } else {
            
        }*/
    }
}

const logIn = (userInfo) => {
    return async (dispatch, getState, { getFirestore, getFirebase }) => {
        const { email, password, rememberMe } = userInfo;
        const fb = getFirebase();
        try {
            await fb.auth().setPersistence(rememberMe ? (fb.auth.Auth.Persistence.LOCAL) : (fb.auth.Auth.Persistence.SESSION))
            await fb.auth().signInWithEmailAndPassword(email, password)
            dispatch({ type: 'LOGIN_SUCCESS' })
        } catch (err) {
            dispatch({ type: 'LOGIN_ERROR', payload: err.message })
        }
    }
}

const logOut = () => {
    return async (dispatch, getState, { getFirebase }) => {
        dispatch({ type: 'IS_LOADING_AUTH' })
        const fb = getFirebase();
        try {
            await fb.auth().signOut()
            dispatch({ type: 'LOGOUT_SUCCESS' })
        } catch (err) {
            console.log(err)
            dispatch({ type: 'LOGOUT_ERROR', payload: err.message })
        }
    }
}

const confirmPasswordReset = (code, password) => {
    return async (dispatch, getState, { getFirebase }) => {
        const fb = getFirebase();
        try {
            await fb.auth().confirmPasswordReset(code, password)
            dispatch({ type: 'PASSWORD_SUCCESS' })
        } catch (err) {
            dispatch({ type: 'PASSWORD_ERROR', payload: err.message })
        }
    }
};

const sendPasswordResetEmail = (email) => {
    return async (dispatch, getState, { getFirebase }) => {
        const fb = getFirebase();
        try {
            await fb.auth().sendPasswordResetEmail(email)
            dispatch({ type: 'PASSWORD_RESET_EMAIL_SUCCESS', payload: 'E-mail enviado com sucesso!' })
        } catch (err) {
            dispatch({ type: 'PASSWORD_RESET_EMAIL_ERROR', payload: err.message })
        }
    }
}

export {
    register,
    logIn,
    logOut,
    confirmPasswordReset,
    sendPasswordResetEmail,
}